// extracted by mini-css-extract-plugin
module.exports = {"background":"X_dZ","values":"X_d0"};